/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Lightweight serializer for user dropdowns (e.g. task assignment).
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface UserMinimal { 
    readonly id: number;
    name: string;
    email: string;
    readonly isTherapist: boolean;
    readonly isPatientops: boolean;
    readonly teamIds: Array<number>;
}
export const UserMinimal_id_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UserMinimal_name_Validators: ValidatorFn[] =
    [  Validators.required,  Validators.maxLength(255),];

export const UserMinimal_email_Validators: ValidatorFn[] =
    [  Validators.required,  Validators.maxLength(254), Validators.email,];

export const UserMinimal_isTherapist_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UserMinimal_isPatientops_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UserMinimal_teamIds_Validators: ValidatorFn[] =
    [  Validators.required, ];


